export default __webpack_public_path__ + "static/media/cover-autolike@2x.a677413c.png";